import React from 'react';
import Tippy from '@tippyjs/react';
import Icon from '../Icon';
import 'tippy.js/dist/tippy.css'; // optional
import 'tippy.js/animations/shift-away.css';
import './style.scss';

const GraphInfoSubtitle = ({ className = '', children }) => {
	return (
		<div className={`graph-info-subtitle__container ${className}`}>
			<Tippy animation="shift-away" placement="right" content={children}>
				<div className="graph-info-subtitle__icon">
					<Icon>info</Icon>
				</div>
			</Tippy>
		</div>
	);
};

export default GraphInfoSubtitle;
